<template>
    <div class="modal fade fixed-end" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="drawer-title">
                        Filter
                    </h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">

                    <div class="mb-3">
                        <label class="control-label">Tag</label>
                        <multiselect :show-labels="false" :options="tags" :searchable="false" label="text" track-by="id" :close-on-select="true" v-model="tagSelected" placeholder="Select Tag" :multiple="true"></multiselect>
                    </div><!-- /.form-group -->

                    <div class="mb-3">
                        <label class="control-label">User Story Status</label>
                        <multiselect :show-labels="false" :options="statuses" :searchable="false" :close-on-select="true" v-model="statusSelected" placeholder="Select Status"></multiselect>
                    </div><!-- /.form-group -->

                    <div class="mb-3">
                        <label class="control-label">Assigned User</label>
                        <multiselect :show-labels="false" :options="users" v-model="usersSelected" label="name" track-by="id" placeholder="Select User" :multiple="true"></multiselect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapActions, mapGetters } from 'vuex'
    import { filter, cloneDeep } from 'lodash'
    import { LaddaButton } from 'components/form/input'
    import Multiselect from 'vue-multiselect'
    import { CModal } from '@chameleon/chameleon-vue'

    export default {
        extends: CModal,

        components: {
            Multiselect
        },

        data: function () {
            return {
                loaded: false,
                statuses: ['New', 'In Progress', 'Completed'],
                // filters: {
                //     users: [],
                //     tags: [],
                //     status: null
                // }
            }
        },

        // watch: {
        //     filters: {
        //         handler(val){
        //           this.setFilters(cloneDeep(this.filters))
        //         },
        //         deep: true
        //     }
        // },

        computed: {

            ...mapState('users', {
                users: 'users'
            }),

            ...mapState('yodizproject/stories', {
                filters: 'filters'
            }),

            ...mapState('yodizproject/tags', {
                tags: 'list'
            }),

            usersSelected: {
                get () {
                    return this.filters.users
                },

                set (value) {
                    this.setStateProperty({ property: 'filters.users', value: value })
                    //this[SET_PROPERTY]({ property: 'filters.users', value: value })
                }
            },
            statusSelected: {
                get () {
                    return this.filters.status
                },

                set (value) {
                    this.setStateProperty({ property: 'filters.status', value: value })
                }
            },

            tagSelected: {
                get () {
                    return this.filters.tags
                },

                set (value) {
                    this.setStateProperty({ property: 'filters.tags', value: value })
                }
            },
        },

        methods: {
            ...mapActions('yodizproject/stories', {
                getStories: 'getList',
                getUserStory: 'getSingle',
                setFilters: 'setFilters',
                setStateProperty: 'setStateProperty'
            }),
        }
    }
</script>